import React from "react";
import "./PrivacyPolicy.CSS";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container m-4 shadow-4 p-5 rounded">
      <h1 className="privacy-title">Privacy Policy</h1>
      <p className="privacy-date">Effective Date: [29-04-2025]</p>
      <p className="privacy-website">Website: https://kidschoice.co.in</p>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect personal information such as your name, email address,
        phone number, and shipping address, as well as payment and usage data.
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>
        Your data is used to process orders, provide support, send updates, and
        improve user experience.
      </p>

      <h2>3. Cookies and Tracking</h2>
      <p>
        We use cookies to enhance your browsing experience. You may disable
        cookies in your browser settings.
      </p>

      <h2>4. Sharing Your Information</h2>
      <p>
        We do not sell your data. It may be shared with service providers such
        as payment processors or delivery partners.
      </p>

      <h2>5. Data Security</h2>
      <p>
        We take reasonable steps to protect your data but cannot guarantee 100%
        security.
      </p>

      <h2>6. Your Rights</h2>
      <p>
        You can request access to, update, or delete your personal data. Contact
        us at support@kidschoice.co.in.
      </p>

      <h2>7. Third-Party Links</h2>
      <p>
        Our site may contain links to other websites. We are not responsible for
        their privacy practices.
      </p>

      <h2>8. Children's Privacy</h2>
      <p>
        We do not knowingly collect information from children under 13 without
        parental consent.
      </p>

      <h2>9. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy occasionally. The latest version will
        be posted on this page.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        If you have questions or concerns, contact us at:
        <br />
        Email: support@kidschoice.co.in
        <br />
        Website: https://kidschoice.co.in
      </p>
    </div>
  );
};

export default PrivacyPolicy;
